import React from 'react';
import styled from 'styled-components';
import theme from 'theme/theme';
import hexToRgba from 'hex-to-rgba';

const returnSize = (size) => {
	if (size === 'medium') return 'padding: 15px 50px;';
	else if (size === 'fit') return 'padding: 10px; width: 100%;';
	else return 'padding: 5px 20px;';
};

const returnType = (type, color) => {
	if (type === 'secondary')
		return `border: 1px solid ${
			color || theme.primary1
		}; background-color: transparent; color: ${color || theme.primary1};`;
	else return `background-color: ${color || theme.primary1}; color: white;`;
};

const Button = ({ children, ...rest }) => {
	return <StyledButton {...rest}>{children}</StyledButton>;
};

const StyledButton = styled.button`
	border: none;
	border-radius: 5px;
	cursor: pointer;
	outline: none;
	${(props) => returnSize(props.size)};
	${(props) => returnType(props.type, props.color)};

	&:hover {
		${(props) =>
			props.type === 'secondary'
				? `background-color: ${
						props.color || theme.primary1
				  }; color: white;`
				: `box-shadow: 1px 3px 10px 3px ${hexToRgba(
						props.color || theme.primary1,
						0.3,
				  )}`};
	}
`;

export default Button;
